






import { Component, Prop, Vue } from 'vue-property-decorator';
import { Restaurant } from '../Restaurant';
import RestaurantInfo from './RestaurantInfo.vue';

@Component<Popup>({
	components: {
		RestaurantInfo,
	},
})
export default class Popup extends Vue {

	//@ts-ignore
	@Prop() restaurant: Restaurant;
	//@ts-ignore
	@Prop() loadMenu: boolean;
}
